import { render, staticRenderFns } from "./MedicalReport.vue?vue&type=template&id=9da6747c&"
import script from "./MedicalReport.vue?vue&type=script&lang=js&"
export * from "./MedicalReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports